import Vue from "vue";

export default {
  namespaced: true,
  state: {
    status: { complete: true, terminating: false },
    lines: [],
    computerUID: null
  },
  mutations: {
    setStatus(state, status) {
      Vue.set(state, "status", { ...state.status, ...status });
    },
    setComputerUID(state, computerUID) {
      Vue.set(state, "computerUID", computerUID);
    },
    addLine(state, line) {
      state.lines.push(line);
    },
    clear(state) {
      Vue.set(state, "status", { complete: true, terminating: false });
      state.computerUID = null;
      state.lines = [];
    }
  }
};
